"use client"

import type React from "react"
import { useState } from "react"
import { Col, Container, Row } from "reactstrap"
import Breadcrumbs from "../../../CommonElements/Breadcrumbs/Breadcrumbs"
import ExhibitorCarList from "./ExhibitorCarList"
import ExhibitorCarModal from "./ExhibitorCarModal"
import type { ExhibitorCar } from "./types"

const ExhibitorCarContainer: React.FC = () => {
  const [modalOpen, setModalOpen] = useState(false)
  const [selectedCar, setSelectedCar] = useState<ExhibitorCar | null>(null)
  const [refreshTrigger, setRefreshTrigger] = useState(false)

  const handleOpenAdd = () => {
    setSelectedCar(null)
    setModalOpen(true)
  }

  const handleOpenEdit = (item: ExhibitorCar) => {
    setSelectedCar(item)
    setModalOpen(true)
  }

  const handleSuccess = () => {
    setModalOpen(false)
    setRefreshTrigger((prev) => !prev)
  }

  return (
    <>
      <Breadcrumbs mainTitle="Cars" parent="Management" />
      <Container fluid>
        <Row>
          <Col md="12">
            <ExhibitorCarList onAdd={handleOpenAdd} onEdit={handleOpenEdit} refreshTrigger={refreshTrigger} />
          </Col>
        </Row>

        <ExhibitorCarModal
          isOpen={modalOpen}
          toggle={() => setModalOpen(false)}
          onSuccess={handleSuccess}
          initialData={selectedCar}
        />
      </Container>
    </>
  )
}

export default ExhibitorCarContainer
